module.exports = __webpack_public_path__ + "img/product.d90958af.png";